const commonStyles = {
  actionColor: {
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  bannerImgPreview: {
    objectFit: "contain",
    maxHeight: "90vh",
    maxWidth: "90vw",
  },
  brandlogo: {
    height: "60px",
  },
  brandlogoSM: {
    height: "50px",
  },
  adminHeaderMenu: {
    position: "absolute",
    transition: "all ease-in-out 1s",
  },
  adminHeaderMenuLinkDark: {
    color: "#ffffff",
    textDecoration: "none",
    minWidth: "250px",
    padding: "10px 10px",
    margin: "1px 0",
    transition: "all ease-in-out 0.5s",
    "&:hover": {
      backgroundColor: "#B1D8B7",
      paddingLeft: "15px",
    },
  },
  adminHeaderMenuLinkLight: {
    color: "#262626",
    textDecoration: "none",
    minWidth: "250px",
    padding: "10px 10px",
    margin: "1px 0",
    transition: "all ease-in-out 0.5s",
    "&:hover": {
      backgroundColor: "#B1D8B7",
      paddingLeft: "15px",
    },
  },
  homeSlider: {
    width: "100vw",
    height: "100% !important",
    objectFit: "cover",
    // filter: "blur(2px)",
  },
  homeSliderContainer: {
    width: "100vw",
    height: "80vh !important",
  },
  homeSliderWrapper: {
    height: "80%",
    width:"100% " 
  },
  homeSliderTextWrap: {
    position: "absolute",
    width: "100vw",
    height: "100%",
    zIndex: 9999,
    top: 0,
    // display: "flex",
    // flexDirection: "column",
    // alignItems: "center",
    // justifyContent: "center",
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  sliderHead: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-end",
  },
  aboutIcon: {
    width: 100,
    height: 100,
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: 30,
    backgroundColor: "white !important",
    transition: "all ease-in-out 0.3s",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },
  imageCard: {
    overflow: "hiden",
    marginTop: "2rem",
    width: "250px",
    height: "420px",
    // background: "#fff",
    borderRadius: "10px 10px 0px 0px",
    boxShadow: "0px 0px 1px #000",
    position: "relative",
    transition: "transform 0.5s",

    "&:after": {
      content: '""',
      position: "absolute",
      width: "0px",
      height: "310px",
      right: 0,
      top: 0,
      backgroundColor: "#e53935",
      opacity: 0.7,
      boxShadow: "0 0 5px #fff",
      borderRadius: "10px 10px 0px 0px",
      transition: "width 0.5s",
    },
    "&:hover&:after": {
      width: "100%",
    },
    "&:before": {
      content: '""',
      position: "absolute",
      width: "100%",
      left: 0,
      height: "4px",
      bottom: 0,
      backgroundColor: "#e53935",
      boxShadow: "0 0 5px #fff",
      borderRadius: "10px 10px 0px 0px",
      transition: "width 0.5s",
    },
    "&:hover&:before": {
      width: 0,
    },
  },

  iconSet: {
    position: "relative",
    overflow: "hidden",
  },

  teamImage: {
    maxWidth: "250px",
    width: "100%",
    height: "310px",
    borderRadius: "10px 10px 0px 0px",
  },
  teamColor: {
    // backgroundColor: "#fff",
    padding: "0.3rem 1rem",
    display: "flex",
    flexDirection: "column",
    borderRadius: "0px 5px 5px 0px",
    position: "absolute",
    top: "50%",
    left: "-10rem",
    transform: "translateY(-50%)",
    zIndex: 999,
    transition: "left 0.5s 0.1s",

    // "${imageCard}:hover": {
    //   left: 0,
    // },

    // "&:hover $imageCard": {
    //   left: 0,
    // },
    // $imageCard: {
    //   '&:hover': {
    //     left: 0,
    //   }
    // },

    svg: {
      margin: "0.5rem 0",
      fill: "blue",

      "&:hover": {
        fill: "red",
      },
    },
  },
  testimonialColor: {
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  slide: {
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    borderRadius: "100px",

    transition: "all ease-in-out 0.3s",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },

  teamImg: {
    width: 100,
    height: 100,
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: 30,
    transition: "all ease-in-out 0.3s",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },
  companyMedia: {
    width: "50%",
    height: "50%",
    objectFit: "contain",
  },
  backgroundMedia: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  cardImage: {
    width: 100,
    height: 100,
    // marginLeft: "auto",
    // marginRight: "auto",
    borderRadius: 100,
  },
  card: {
    transition: "all ease-in-out 0.5s",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },
  serviceCardImage: {
    width: "100%",
    maxHeight: "300px",

    // min: "100%",
    // margin: 20,
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "auto",
    objectFit: "contain",
  },
  galleryCardImage: {
    width: "100%",
    maxHeight: "300px",

    height: "100%",
    // margin: 20,
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "auto",
    objectFit: "contain",
  },
  cards: {
    transition: "all ease-in-out 0.5s",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },
  galleryCardImages:{
    transition: "all ease-in-out 0.5s",
    "&:hover": {
      transform: "scale(1.05)",
    },

  }
  
};
export default commonStyles;
